import { useForm, Controller } from "react-hook-form";
import { TextInput, Select, SimpleGrid, Button, Title, Group } from "@mantine/core";
import { fetcher } from "../../../../services/fetcher";
// import { DateInput } from "@mantine/dates";
import useSWR from "swr";
import { useEffect } from "react";
import classes from "./QRCodeForm.module.css";

const packageEndpoint = "operator/packages";

const QRCodeForm = ({ onSubmit, initialData }) => {
  const { handleSubmit, control, register, setValue } = useForm();
  const { data: packages } = useSWR(packageEndpoint, (url) => fetcher(url, "GET"));

  const packageOptions = packages
    ? packages.map((pkg) => ({ value: pkg.id.toString(), label: pkg.title }))
    : [];

  // Prefill form in edit mode
  useEffect(() => {
    if (initialData) {
      setValue("name", initialData.name);
      setValue("package", initialData.package.toString());
      setValue("expiration_date", initialData.expiration_date);
    }
  }, [initialData, setValue]);

  return (
    <>
      <Title className={classes.heading} mb="lg">
        {initialData ? "Edit QR Code" : "Generate QR Code"}
      </Title>
      <form onSubmit={handleSubmit(onSubmit)}>
        <SimpleGrid cols={{ base: 1, xs: 1, sm: 2, lg: 2 }} spacing="xl" className={classes.layout}>
          <TextInput label="Name" placeholder="Name" {...register("name")} />
          <Controller
            name="package"
            control={control}
            render={({ field }) => (
              <Select {...field} label="Select Package" placeholder="Select package" data={packageOptions} />
            )}
          />
          <TextInput label="Expiration Date" placeholder="YYYY-MM-DD" {...register("expiration_date")} />
          {/* <Controller
            name="expiration_date"
            control={control}
            render={({ field }) => (
              <DateInput {...field} label="Expiration Date" placeholder="Select date" />
            )}
          /> */}
        </SimpleGrid>
        <Group justify="center">
          <Button variant="outline" type="submit" mt="xl" mb="lg" size="md">
            {initialData ? "Update" : "Submit"}
          </Button>
        </Group>
      </form>
    </>
  );
};

export default QRCodeForm;